import { createContext, useContext } from "react";

const ChatContext = createContext({});

export const ChatContextProvider = ChatContext.Provider;
export const ChatContextConsumer = ChatContext.Consumer;

export const useChatContext = () => useContext(ChatContext);

export default ChatContext;
